import { computed } from "vue";
import { createGlobalState, useLocalStorage } from "@vueuse/core";
import { useIsInternalUser } from "@/services/user";

const usePreviewState = createGlobalState(() => ({
  enabled: useLocalStorage("feedbackSurveyPreview", false),
  done: useLocalStorage("feedbackSurveyPreviewDone", false),
}));

export function useFeedbackSurveyPreview() {
  const { enabled, done } = usePreviewState();
  const isInternalUser = useIsInternalUser();

  const active = computed(
    () =>
      (import.meta.env.DEV || isInternalUser.value) &&
      enabled.value &&
      !done.value,
  );

  function start() {
    enabled.value = true;
    done.value = false;
  }

  function stop() {
    enabled.value = false;
  }

  function finish() {
    done.value = true;
  }

  return { active, enabled, start, stop, finish };
}
